export default "__VITE_ASSET__CpkS6srM__"